import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetPaymentDetailResponse,
  GetPaymentsRequest,
  GetPaymentsResponse,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";

const { paymentService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: paymentService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Payment"],
  endpoints: (builder) => ({
    getPayments: builder.query<GetPaymentsResponse, GetPaymentsRequest>({
      query: ({orgToken, ...params}) => {
      return {
        url: `payments`,
        method: "GET",
        params: {
          ...params
        },
        headers: {
          'org-token': orgToken
        }
      }}
    }),
    getPaymentDetail: builder.query<GetPaymentDetailResponse, string>({
      query: (paymentId) => {
      return {
        url: `payments/${paymentId}`,
        method: "GET",
        // headers: {
        //   'org-token': orgToken
        // }
      }}
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useGetPaymentDetailQuery
} = paymentApi;
export const { useQueryState: useGetpaymentState } =
  paymentApi.endpoints.getPayments;
